var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-alert',{attrs:{"color":"error"}},[_c('div',{staticStyle:{"color":"#FFFFFF"}},[_vm._v("You don't have permission to access this page")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }